import { useState } from "react";
import { useEditVideoMutation } from "../../../features/videos/videosApi";
import { useNavigate } from "react-router-dom";

export default function EditVideo({ video }) {
  const {
    id,
    title: initialTitle,
    description: initialDescription,
    url: initialUrl,
    duration: initialDuration,
    views: initialViews,
  } = video;

  const navigate = useNavigate();

  const [editVideo, { isLoading, isError, isSuccess }] = useEditVideoMutation();

  const [title, setTitle] = useState(initialTitle);
  const [description, setDescription] = useState(initialDescription);
  const [url, setUrl] = useState(initialUrl);
  const [duration, setDuration] = useState(initialDuration);
  const [views, setViews] = useState(initialViews);

  const handleSubmit = (e) => {
    e.preventDefault();
    editVideo({
      id,
      data: {
        title,
        description,
        url,
        duration,
        views,
      },
    });
  };

  if (isSuccess) navigate("/admin/videos");

  return (
    <form className="video-form" onSubmit={handleSubmit}>
      <div className="space-y-2">
        <label>Video Title</label>
        <input
          required
          className="text-input"
          type="text"
          name="title"
          value={title}
          placeholder="Enter Video Title"
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      <div className="space-y-2">
        <label>Video Url</label>
        <input
          required
          className="text-input"
          type="text"
          name="url"
          placeholder="Enter Video Link"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
      </div>

      <div className="space-y-2">
        <label>Views</label>
        <input
          required
          className="text-input"
          type="text"
          name="views"
          placeholder="Enter Video Views"
          value={views}
          onChange={(e) => setViews(e.target.value)}
        />
      </div>
      <div className="space-y-2">
        <label>Duration</label>
        <input
          required
          className="text-input"
          type="text"
          name="duration"
          placeholder="Enter Video Duration"
          value={duration}
          onChange={(e) => setDuration(e.target.value)}
        />
      </div>
      <div className="space-y-2">
        <label>Description</label>
        <textarea
          required
          className="text-input"
          type="text"
          name="duration"
          placeholder="Brief description for your video"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
      <button
        disabled={isLoading}
        type="submit"
        className="submit"
        id="lws-submit"
      >
        Update Video
      </button>
      <div>
        {isSuccess && (
          <p className="text-center" style={{ color: "green" }}>
            Video Update successfully
          </p>
        )}
        {isError && (
          <p className="text-center" style={{ color: "red" }}>
            There was an error!
          </p>
        )}
      </div>
    </form>
  );
}
